import React, { useEffect, useRef } from 'react';
import { LuTrash2 } from 'react-icons/lu';
import Button from '../../../../components/common/Button/Button';
import { translate } from '../../../../utils/Common';

const t = (key) => translate(`dashboard.platforms.doors.delete.${key}`);

/**
 * Confirmación de eliminar puerta dentro del formulario, sin modal: aparece arriba de los campos,
 * con el foco en la acción y Escape para cancelar. Con paquetes dentro solo explica por qué no se puede.
 */
const DeleteDoorConfirm = ({ doorNumber, hasPackages, isDeleting, onCancel, onConfirm }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    containerRef.current?.querySelector('[data-autofocus]')?.focus();
  }, [hasPackages]);

  return (
    <div
      ref={containerRef}
      role="alertdialog"
      aria-labelledby="delete-door-title"
      aria-describedby="delete-door-body"
      onKeyDown={(e) => { if (e.key === 'Escape' && !isDeleting) onCancel(); }}
      className="col-span-12 mb-4 rounded-xl border border-destructive/30 bg-destructive/5 p-3 animate-in fade-in-0 slide-in-from-top-1 duration-200"
    >
      <div className="flex gap-3">
        <span className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-destructive/10 text-destructive">
          <LuTrash2 size={16} />
        </span>
        <div className="min-w-0 flex-1">
          <p id="delete-door-title" className="text-sm font-semibold text-foreground">
            {t('title')} {doorNumber}?
          </p>
          <p id="delete-door-body" className="mt-0.5 text-xs leading-5 text-muted-foreground">
            {hasPackages ? t('hasPackages') : t('body')}
          </p>
          <div className="mt-3 flex flex-wrap justify-end gap-2">
            <Button variant="ghostOutline" size="sm" onClick={onCancel} disabled={isDeleting} data-autofocus={hasPackages || undefined}>
              {translate('global.cancel')}
            </Button>
            {!hasPackages && (
              <Button variant="danger" size="sm" leftIcon={<LuTrash2 size={14} />} loading={isDeleting} onClick={onConfirm} data-autofocus>
                {t('confirm')}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteDoorConfirm;
